<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card shadow="always">
      <order-detail
        ref="editForm"
        :formData="detailFormData"
        :disabled="isDisableEditForm"
      />
    </el-card>
    <el-card shadow="always" class="mt-2">
      <div class="side-frame-danger">
        <span class="side-frame-text">收发货地址</span>
      </div>
      <order-point
        ref="pickupForm"
        :code="code"
        :formData="pickupFormData"
        :disabled="isDisableEditForm"
      />
      <point-receiving
        ref="receivingForm"
        :code="code"
        :formData="receiveFormData"
        :disabled="isDisableEditForm"
      />
    </el-card>
    <el-card shadow="always" class="mt-2">
      <order-goods
        ref="goodsForm"
        :code="code"
        :tableData="goodsData"
        :detailFormData="detailFormData"
        :disabled="isDisableEditForm"
      />
    </el-card>
    <el-card shadow="always" class="mt-2" v-if="orderPackingDisabled">
      <order-packing
        ref="packingForm"
        :tableData="packingsData"
        :disabled="isDisableEditForm"
      />
    </el-card>
    <el-card shadow="always" class="mt-2" v-if="contractVisible">
      <div class="side-frame-success">
        <span class="side-frame-text">订单收入</span>
      </div>
      <order-income
        ref="incomeForm"
        :code="code"
        :formData="incomeFormData"
        :disabled="isDisableEditForm"
      />
    </el-card>
    <div class="d-flex justify-content-end mt-2 mb-2">
      <el-button
        type="primary"
        size="small"
        @click="save()"
        v-if="!isDisableEditForm"
        :disabled="
          detailFormData.orderStatus !== 'N' &&
            detailFormData.orderStatus !== 'X'
        "
        >保存订单</el-button
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import OrderDetail from './components/order-detail'
import OrderPoint from './components/order-point'
import PointReceiving from './components/order-point-receiving'
import OrderGoods from './components/order-goods'
import OrderIncome from './components/order-income'
import OrderPacking from '../detail/components/order-packing'
export default {
  name: 'carriage-order-detail',
  components: {
    OrderDetail,
    OrderPoint,
    PointReceiving,
    OrderGoods,
    OrderIncome,
    OrderPacking,
  },
  data() {
    return {
      dialogVisible: false,
      code: '',
      disabled: false,
      detailFormData: {},
      pickupFormData: {},
      receiveFormData: {},
      goodsData: [],
      orderPackingDisabled: false,
      contractVisible: false,
      incomeFormData: {},
      packingsData: [],
      fullScreenLoading: false,
      custCode: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    this.code = this.params.orderCode
    this.querySysParams()
    this.querySysContractVisible()
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      let params = {
        orderCode: this.code,
      }
      this.$api.bizOrderInfoDetailApi(params).then((res) => {
        this.detailFormData = res.body
        this.pickupFormData = res.body.pickupPoint
        this.receiveFormData = res.body.receivingPoint
        this.goodsData = res.body.goodsList
        this.incomeFormData = res.body.income
        this.packingsData = res.body.packingList
      })
    },
    async save() {
      // 获取订单主信息
      const getFormData = await this.$refs.editForm.getFormData()

      if (!getFormData) {
        return
      }
      if (!getFormData.vehicleLoad) {
        getFormData.vehicleLoad = 0
      }
      if (!getFormData.vehicleVolume) {
        getFormData.vehicleVolume = 0
      }
      // 获取发货方信息
      const getPickupData = await this.$refs.pickupForm.getPickupData()
      if (!getPickupData) {
        return
      }
      // 获取收货方信息
      const getReceivingData = await this.$refs.receivingForm.getReceivingData()
      if (!getReceivingData) {
        return
      }
      // 获取订单产品信息
      const getGoodsData = await this.$refs.goodsForm.getGoodsData()
      if (!getGoodsData) {
        return
      }

      // 获取订单用箱需求信息
      let getPackingData
      if (this.orderPackingDisabled) {
        getPackingData = await this.$refs.packingForm.getPackingData()
      }
      if (this.orderPackingDisabled && !getPackingData) {
        return
      }
      let getIncomeData
      if (this.contractVisible) {
        // 获取订单收入信息
        getIncomeData = await this.$refs.incomeForm.getIncomeData()
      }
      if (this.contractVisible && !getIncomeData) {
        return
      }

      // 合成订单提交参数
      let params = {
        ...getFormData,
        pickupPoint: getPickupData,
        receivingPoint: getReceivingData,
        ...getGoodsData,
        packingList: getPackingData,
        income: getIncomeData,
      }
      this.fullScreenLoading = true
      this.$api
        .bizOrderInfoSaveApi(params)
        .then((res) => {
          this.fullScreenLoading = false
          this.code = res.body.orderCode
          this.saveOkQuestion()

          //刷新列表
          this.$eventBus.$emit('orderTableReload')
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    saveOkQuestion() {
      this.$alert('订单数据保存成功', '提示信息', {
        confirmButtonText: '确定',
        callback: () => {
          this.closeCurPage()
        },
      })
    },
    async builderNextOrder() {
      // 清空界面，创建下一张订单
      this.$refs.editForm.reset()
      this.$refs.pickupForm.reset()
      this.$refs.receivingForm.reset()
      this.$refs.goodsForm.reset()
      if (this.contractVisible) {
        this.$refs.incomeForm.reset()
      }
      this.dialogVisible = false
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    async getTempData() {
      // 获取订单主信息
      const getFormData = await this.$refs.editForm.getFormData()
      if (!getFormData) {
        return
      }
      // 获取发货方信息
      const getPickupData = await this.$refs.pickupForm.getPickupData()
      if (!getPickupData) {
        return
      }
      // 获取收货方信息
      const getReceivingData = await this.$refs.receivingForm.getReceivingData()
      if (!getReceivingData) {
        return
      }
      // 获取订单产品信息
      const getGoodsData = await this.$refs.goodsForm.getGoodsData()
      if (!getGoodsData) {
        return
      }
      //获取订单用箱需求信息
      let getCoolerData
      if (this.orderPackingDisabled) {
        getCoolerData = await this.$refs.packingForm.getPackingData()
      }
      if (this.orderPackingDisabled && !getCoolerData) {
        return
      }
      // 合成订单提交参数
      let params = {
        ...getFormData,
        pickupPoint: getPickupData,
        receivingPoint: getReceivingData,
        ...getGoodsData,
        coolerList: getCoolerData,
      }
      return params
    },
    querySysParams() {
      this.$api
        .bizOrderPackingQueryStatusApi({ paramID: 'orderPacking' })
        .then((res) => {
          this.orderPackingDisabled = res.body.flag
        })
    },
    querySysContractVisible() {
      this.$api
        .bizOrderPackingQueryStatusApi({ paramID: 'contractVisible' })
        .then((res) => {
          this.contractVisible = res.body.flag
        })
    },
  },
}
</script>
